<template>
	<card no-spacing flat max-height="500">
		<div class="p-8">
			<div class="flex items-center">
				<avatar :src="props.participation.avatar_thumbnail" class="mr-12" :size="32" round/>
				<div class="flex flex-column">
					<div class="flex items-center">
						<span v-if="props.participation.display_name" class="text-sm font-bold">{{ props.participation.display_name }}</span>
						<i class="text-sm font-bold" v-else>{{ t('label.anonymous') }}</i>
						<span v-if="props.participation.starter_number" class="text-xs ml-8 text-gray-400">#{{ props.participation.starter_number }}</span>
					</div>

					<div v-if="props.participation.gender" class="text-2xs text-gray-400 mt-4">{{ props.participation.gender === 'm' ? t('label.male') : t('label.female') }}</div>
				</div>
			</div>

			<description-list v-if="props.participation.started_at" class="mt-12" small>
				<description-list-item :title="t('label.started_at')" :text="$date(props.participation.started_at).format('DD.MM.YYYY HH:mm')"/>
				<description-list-item v-if="props.participation.finished_at" :title="t('label.finished_at')" :text="$date(props.participation.finished_at).format('DD.MM.YYYY HH:mm')"/>
				<description-list-item v-if="activeTime || props.participation.time" :title="t('label.time')" :text="activeTime ?? props.participation.time"/>
				<description-list-item v-if="latLng.distance_from_start || props.participation.distance" :title="t('label.distance')" :text="n((latLng.distance_from_start ?? props.participation.distance) / 1000, {maximumFractionDigits: 2}) + ' km'"/>
				<description-list-item v-if="latLng.speed && props.paceType" :title="t('label.pace')" :text="convertSpeedToPace(props.paceType, latLng.speed)"/>
			</description-list>

			<description-list v-if="props.participation.ranks && props.participation.ranks.length" small>
				<description-list-item v-for="(rank, rankKey) in props.participation.ranks" :key="`rank-${props.participation.id}-${rankKey}`" :title="rank.name" :text="rank.rank ? `${rank.rank}. ${t('label.rank')}` : '-'" :text-space="2/5"/>
			</description-list>

			<btn v-if="props.to" :to="props.to" small class="mt-16 w-full">{{ t('action.show_details') }}</btn>
		</div>
	</card>
</template>

<script setup lang="ts">
import {useI18n, useNuxtApp} from '#imports';
import {onBeforeUnmount, ref} from "vue";
import {type ActivityLatLng, convertSpeedToPace, type PaceType} from "@spoferan/spoferan-ts-core";

const props = defineProps<{
	participation: object,

	latLng?: ActivityLatLng,

	// The pace type of the participation class
	paceType?: PaceType,

	// Whether the location of the marker is currently live
	live?: boolean,

	to?: string,
}>();

const {t, n} = useI18n();
const {$date} = useNuxtApp();

let timeRefreshInterval = null;
const activeTime = ref(null);

function refreshActiveTime() {
	if (!props.live || !props.participation.started_at) {
		return;
	}
	if (timeRefreshInterval) {
		clearInterval(timeRefreshInterval);
	}
	timeRefreshInterval = setInterval(() => {
		activeTime.value = $date().timeDiff(props.participation.started_at);
	}, 1000);
}

refreshActiveTime();

onBeforeUnmount(() => {
	if (timeRefreshInterval) {
		clearInterval(timeRefreshInterval);
	}
});

</script>